__webpack_require__.p = "/mastermind-frontend/";